import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ProjectPlanModel, ProjectPlanQuestion, ProjectQuestionResponseModel } from '../../models/project-plan.model';
import { ProjectPlanService } from '../../services/project-plan.service';
import { ProjectPlanViewModel } from '../../models-views/project-plan.view.model';
import { BehaviorSubject, debounceTime, Observable, Observer, Subject, takeUntil } from 'rxjs';
import LoginModel from '../../models/user.model';
import { AppCommon } from '../../providers/app-common';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-project-plan-drawer',
  standalone: false,
  templateUrl: './project-plan-drawer.component.html',
  styleUrl: './project-plan-drawer.component.scss',
  providers: []
})
export class ProjectPlanDrawerComponent implements OnDestroy {

  fileList: NzUploadFile[] = []
  scfileList: NzUploadFile[] = []
  @Input() isVisible = false;
  isVisibleAddQuestion = false;
  stepIndex = 0;
  Array = Array;
  @Output() closeDrawer = new EventEmitter<boolean>();
  projectPlanData: ProjectPlanModel | null = null;
  projectPlanModel = new BehaviorSubject<ProjectPlanModel>(new ProjectPlanModel());
  projectQuestion = new BehaviorSubject<ProjectQuestionResponseModel>(new ProjectQuestionResponseModel());
  questions: ProjectPlanQuestion[] = [];
  disable = false;
  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
  loading:boolean = false;
  loggedInUser
  nameSearchModel = '';
  private searchChange = new Subject<string>();
  private destroy$ = new Subject<void>();
  deleteFileAction:any = null
  deleteMultiFileAction:any = null
  constructor(
    private projectPlanService: ProjectPlanService,
    private vm: ProjectPlanViewModel,
    private message: NzMessageService,
  ) {
     this.loginModel.next(AppCommon.getloggedInObject());
    this.loggedInUser = AppCommon.getloggedInObject().user
  }

  ngOnInit(): void {
    this.setupDataFromService();
    this.vm.parentProjectPlanDrawerComponent = this;
    this.vm.subscribeToProjectPlanModel(this.projectPlanModel);
    this.vm.subscribeToProjectQuestion(this.projectQuestion);
    this.vm.getProjectQuestions(1, 100);

     this.searchChange.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe(
      (text) => {
        this.nameSearchModel = text;
        this.vm.getProjectQuestions(1, 100, this.nameSearchModel);
      }
    );

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fileDownloaded(e:any,type:any){
    let file = e;
    file['uid']= file.id,
    file['name']= file.name,
    file['status']= 'done',
    file['url']= file.file

    if(type == 'File'){
      this.fileList.push(file);
    }else{
      this.scfileList.push(file);
    }
  }

  formatIdToFourDigits(id: number): string {
    return id ?  'PR'+ id.toString().padStart(4, '0') : '';
  }

  setupDataFromService(){
    this.projectPlanService.planData$.pipe(takeUntil(this.destroy$)).subscribe((data: ProjectPlanModel | null) => {
      if (!data) return;
      this.loading = false
      this.projectPlanData = data;
      this.updateProjectQuestion();
    });
  }

  updateProjectQuestion(){
    // planData$ is a shared BehaviorSubject: don't mutate its answers in place, or a second
    // subscriber (or a re-emit) sees arrays and `.split` throws before questions are built.
    const answersMap = new Map<number, string[]>();
    (this.projectPlanData.onboarding_plan_details || []).forEach(q => {
      const ans: string[] = Array.isArray(q.answer)
        ? q.answer
        : String(q.answer ?? '').split(',').map(item => item.trim());
      for(let i = 0; i < ans.length; i++){
        if(ans[i] !== '' && !Number.isNaN(Number(ans[i]))){
          this.vm.getMediaFile(ans[i],q.question_details?.question_type_details?.name)
        }
      }
      answersMap.set(q.question, ans);
    })

    const questions_list = (this.projectPlanData.onboarding_q_plan_details || []).map(q => ({
      id: q.id,
      text: q.question,
      type: q.question_type_details?.name,
      options: (q.multiple_choice || '').split(',').map(o => o.trim()).filter(o => o !== ''),
      answer: null
    }));

    this.questions = questions_list.map(q => ({...q, answer: answersMap.get(q.id) ?? null}));
  }





  onIndexChange(index: number): void {
    this.stepIndex = index;
  }


  customUploadRequest = (item: any) => {
    return  this.vm.uploadMediaFile(item, this.loggedInUser.id)
  }

   onUploadContractChange(event: any,index:any): void {
    //  console.log('Upload Event:', event);
     if (event.type === 'success') {
      //  console.log('File uploaded successfully:', event.file);
      //  this.projectForm.get('contract_files')?.setValue([...this.projectForm.get('contract_files').value , event.file.response.id] , { emitEvent: false });
      this.questions[index].answer = this.Array.from( new Set([...this.scfileList.map((f:any) =>  f.id), event.file.response.id])).filter(f => f != undefined);
      console.log('File uploaded successfully:', event.file, this.scfileList,this.questions[index]);
     } else if (event.type === 'error') {
      //  console.error('File upload failed:', event.file);
     } else if(event.type == 'removed'){
      // this.deleteMultiFileAction = event.file
      this.scfileList = this.scfileList.filter(f => f.uid !== event.file.uid);
      this.questions[index].answer = this.Array.from( new Set([...this.scfileList.map(f => f.response.id) ]));
      // this.vm.deleteMediaFile(event.file.id);
      // this.projectForm.get('contract_files')?.setValue([...this.scfileList.map(f => f.uid)] , { emitEvent: false });
     }

   }

   removeMultiFile(e:any,event:any,index:any){
    // console.log(e,event)
    e.preventDefault();
      // this.scfileList = this.scfileList.filter(f => f.uid !== event.file.uid);
      this.vm.deleteMediaFile(event.id,'Multiple File',index);
  }

  cancelRemoveMultiFile(e:any){
    e.preventDefault();
    this.deleteMultiFileAction = null
  }

  fileDeleted(type:any,index:any){
    if(type == 'File'){
      this.fileList = this.fileList.filter(f => f.uid !== this.deleteFileAction.uid);
      this.questions[index].answer = this.Array.from( new Set([...this.fileList.map(f => f.response.id) ]));
    } else{
       this.scfileList = this.scfileList.filter(f => f.uid !== this.deleteMultiFileAction.uid);
       this.questions[index].answer = this.Array.from( new Set([...this.scfileList.map(f => f.response.id) ]));
    }

  }


   onUploadAdditionalChange(event: any,index:any): void {
    console.log('Upload Event:', event);
    if (event.type === 'success') {
      // this.projectForm.get('additional_files')?.setValue( [ ...this.projectForm.get('additional_files').value ,event.file.response.id], { emitEvent: false });

      this.questions[index].answer = this.Array.from( new Set([...this.fileList.map((f:any) =>  f.id) , event.file.response.id])).filter(f => f != undefined);
      console.log('File uploaded successfully:', event.file, this.fileList,this.questions[index]);
    } else if (event.type === 'error') {
      // console.error('File upload failed:', event.file);
    } else if(event.type == 'removed'){
      // this.deleteFileAction = event.file
      this.fileList = this.fileList.filter(f => f.uid !== event.file.uid);
      this.questions[index].answer = this.Array.from( new Set([...this.fileList.map(f => f.response.id) ]));
      // this.vm.deleteMediaFile(event.file.id);
    }

  }

removeFile(e:any,event:any,index:any){
  console.log(e,event)
  e.preventDefault();
  // this.fileList = this.fileList.filter(f => f.uid !== event.uid);
  this.vm.deleteMediaFile(event.id, 'File',index);
}

cancelRemoveFile(e:any){
  e.preventDefault();
  this.deleteFileAction = null
}


    beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> =>
      new Observable((observer: Observer<boolean>) => {
          const isLt5M = file.size! / 1024 / 1024 < 5;
          if (!isLt5M) {
              this.message.error(`${file.name} is larger than 5MB!`);
              observer.next(false); // Emit false to indicate validation failed
              observer.complete();
          } else {
              observer.next(true); // Emit true to indicate validation passed
              observer.complete();
          }
      });

  removeDefault(e:any){
    e.preventDefault();
    // e.stopPropagation();
  }

  getFiles(type:string,id:number){
    if(type =='File'){
      return   this.fileList.filter((f:any) => f.id == id || f.response.id == id )[0]?.name
    }else{
     return this.scfileList.filter((f:any) => f.id == id  || f.response.id == id )[0]?.name
    }

  }

  submitAnswers() {
    const answers = this.questions.filter(q => q.answer !== null).map(q => ({question: q.id, answer: q.answer}));
    const payload = {project_plan: this.projectPlanData.id, payload: answers, user: this.loginModel.value.user.id};
    this.loading= true
    this.vm.updateProjectPlanAns(payload);
  }


  getCheckboxOptions(q: ProjectPlanQuestion) {
    return q.options?.map(o => ({ label: o, value: o })) || [];
  }


  open(): void {
    this.isVisible = true;
  }

  close(): void {
    this.stepIndex = 0;
    this.isVisible = false;
    this.loading= false
    this.projectPlanService.clearPlanData();
    this.closeDrawer.emit(true);
  }


  nextStep(): void {
    if (this.stepIndex < 2) {
      this.stepIndex++;
    }
  }



  addNewQuestion(): void {
    this.isVisibleAddQuestion = true;
  }

  handleCancel(){
    this.isVisibleAddQuestion = false;
    this.refreshProjectPlan();
  }

  handleOk(){
    this.isVisibleAddQuestion = false;
    this.refreshProjectPlan();
  }


  checkedChange({ id, checked }: any): void {
    const { onboarding_q_plan, id: projectId } = this.projectPlanData;
    this.projectPlanData.onboarding_q_plan = checked
      ? onboarding_q_plan.includes(id) ? onboarding_q_plan : [...onboarding_q_plan, id]
      : onboarding_q_plan.filter(item => item !== id);
    this.vm.updateProjectPlan({
      id: projectId,
      onboarding_q_plan: this.projectPlanData.onboarding_q_plan
    });
  }

  refreshProjectPlan(){
    this.vm.getProjectPlanbyID(this.projectPlanData.id);
  }

  projectPlanReceived(){
    this.projectPlanData = this.projectPlanModel.value;
    this.updateProjectQuestion();
  }


  updatedProjectPlanAns(){
    this.close();
  }


  isCheckedQuation(id: number){
    if(!this.projectPlanData.onboarding_q_plan){
      return false
    }
    return this.projectPlanData.onboarding_q_plan.includes(id)
  }


  getStatusColor(status: string): string {
    switch (status) {
      case 'Open': return 'purple';
      case 'In-Progress': return 'blue';
      case 'On-Hold': return 'orange';
      case 'Closed': return 'cyan';
      case 'Completed': return 'green';
      case 'Lost': return 'red';
      default: return 'default';
    }
  }

  getBase64Image(data: string){
    return 'data:image/png;base64,' + data;
  }


  onSearchChange(value: string) {
    this.searchChange.next(value);
  }

}
